import '../css/styles.css'
import * as Quill from 'quill';
import 'quill-mention';
const Parse = require('parse');

// This sets up the parse server 
const STORAGE_ROOT = 'fnsz_app_last_';
const SERVER_URL = 'https://funsizeapps.b4a.app/';
const APP_ID = 'rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9';
const JAVASCRIPT_KEY = 'xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv';
const REST_API_KEY = 'fabjEVYWZCwtBWXZ62BF3oAjU7ZzipumKecJidKJ';
Parse.initialize(APP_ID, JAVASCRIPT_KEY);
Parse.serverURL = SERVER_URL;

var funsizer, funsizerParseId, funsizerName, ffMessage, itsASubmitButton, ffMessage, modal, modalCloseButton, funFiveFeed, noFives, givenButton, receivedButton, quill, selector, reactMenu, currentFives, ffReactId;
var peeps = [];
var mentionablePeeps = [];
var currentlyMentionablePeeps = [];
var currentlyMentionedPeeps = [];
var funfives = [];
var receivedFives = [];
var givenFives = [];

const reactions = [
  { name: ':heart:', value: '❤️' },
  { name: ':100:', value: '💯' },
  { name: ':raised-hands:', value: '🙌' },
  { name: ':fire:', value: '🔥' },
  { name: ':clap:', value: '👏' },
  { name: ':sick:', value: '🤮' }
];

const createFunFive = async () => {
  const rIds = currentlyMentionedPeeps.map(cmp => cmp.id);
  const rEmails = peeps.filter(p => rIds.includes(p.id)).map(fp => fp.get('Email'));
  try {
    const params = {
      senderName: funsizerName,
      senderId: funsizerParseId,
      recipientIds: rIds,
      recipientEmails: rEmails,
      message: ffMessage
    };
    const res = await Parse.Cloud.run('appFunFive', params);
    return res;
  } catch (error) {
    throw error;
  }
};

window.addEventListener('load', () => {
  gsap.to(document.getElementsByClassName('loader-container')[0], { opacity: 1, duration: 0.25 });
  gsap.to(document.getElementsByClassName('loader')[0], { scale: 0.5, duration: 1, ease: "bounce.out", repeat: -1, yoyo: true });
  itsASubmitButton = document.getElementById('funfive-submit');
  itsASubmitButton.addEventListener('click', itsASubmitButtonClicked);
  modal = document.getElementsByClassName('modal-wrapper')[0];
  modalCloseButton = document.getElementById('modal-close-btn');
  modalCloseButton.addEventListener('click', modalCloseButtonClicked);
  funFiveFeed = document.getElementById('feed');
  noFives = document.getElementsByClassName('empty-container')[0];
  givenButton = document.getElementById('given-button');
  receivedButton = document.getElementById('recieved-button');
  selector = document.getElementById('select-date');
  selector.addEventListener('change', dateSelectorChanged);
  document.getElementById('modal-facestack').addEventListener('mouseenter', runFunFiveHover);
  reactMenu = document.getElementById('reaction-menu');
  reactions.forEach(react => {
    const b = document.createElement('button');
    b.id = react.name;
    b.innerHTML = react.value;
    b.addEventListener('click', (e) => {
      var ff = funfives.filter(f => f.id == ffReactId)[0];
      var ffReactions = ff.get('Reactions');
      if(!ffReactions){
        ffReactions = [];
      }
      //if this reaction exists for this user then it's a remove, otherwise it is an add
      const ffReaction = ffReactions.filter(r => r.name == e.target.id)[0];
      if (!ffReaction) {
        ffReactions.push({name:e.target.id, ids:[funsizerParseId]});
      }
      else {
        if(ffReaction.ids.includes(funsizerParseId)){
          ffReaction.ids = ffReaction.ids.filter(id => id != funsizerParseId);
        }
        else {
          ffReaction.ids.push(funsizerParseId);
        }
      }
      ff.set('Reactions', ffReactions);
      ff.save().then((r) => {
        ff = r;
        renderFunFive(ff, true);
        reactMenu.classList.add('thanos');
      }, (error) => {
        reactMenu.classList.add('thanos');
        alert('Failed saving reaction: ' + error);
      });
    });
    reactMenu.appendChild(b);
  });

  givenButton.addEventListener("click", () => {
    if (givenButton.classList.contains('selected')) {
      dateSelectorCore();
    } else {
      currentFives = givenFives;
    }
    if (receivedButton.classList.contains('selected')) { receivedButton.classList.toggle('selected'); }
    givenButton.classList.toggle('selected');
    renderFivesCore();
  });
  receivedButton.addEventListener('click', () => {
    if (receivedButton.classList.contains('selected')) {
      dateSelectorCore();
    } else {
      currentFives = receivedFives;
    }
    if (givenButton.classList.contains('selected')) { givenButton.classList.toggle('selected'); }
    receivedButton.classList.toggle('selected');
    renderFivesCore();
  });
  initFunsizer();
});

const resetFilters = () => {
  if (givenButton.classList.contains('selected')) { givenButton.classList.toggle('selected'); }
  if (receivedButton.classList.contains('selected')) { receivedButton.classList.toggle('selected'); }
}

const initFunsizer = () => {
  funsizer = Parse.User.current();
  if (funsizer) {
    getPeeps().then(() => {
      const p = peeps.filter(p => p.get('Email') == funsizer.get('email'))[0];
      funsizerName = p.get('Name');
      funsizerParseId = p.id;
      setUpInputField();
      getFunFives().then(() => {
        dateSelectorChanged();
        updateGivenReceivedArrays();
        renderFivesCore();
        gsap.to(document.getElementsByClassName('loader-container')[0], { opacity: 0, duration: 0.25 });
        const hiddens = document.getElementsByClassName('hidden');
        for (var i = 0; i < hiddens.length; i++) {
          gsap.to(hiddens[i], { opacity: 1, duration: 0.35, delay: 0.2 * i });
        }
        handleModal();
      }).catch(function (e) {
        handleParseError('Error when gettin funfives', e);
        console.log(`Error when gettin funfives : ${e.code} - ${e.message}`);
      });
    }).catch(function (e) {
      handleParseError('Error when fetching peeps', e);
      console.log(`Error when fetching peeps : ${e.code} - ${e.message}`);
    });
  } else {
    window.location = `${window.location.origin}/${(window.location.pathname.includes("staging") ? "staging/" : "")}login.html?redirect=${window.location.pathname}`;
  }
};

const handleModal = () => {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  const ffId = params.id;
  if (ffId != null) {
    const ff = funfives.filter(ff => ff.id == ffId)[0];
    const sender = peeps.filter(p => p.id == ff.get('SenderId'))[0];
    const recipientIds = ff.get('RecipientIds');
    const recipients = peeps.filter(p => recipientIds.includes(p.id));

    const messageContent = ff.get('Message');
    modal.style.display = 'flex';
    removeAllChildNodes(document.getElementById('modal-facestacksub'));
    removeAllChildNodes(document.getElementById('modal-recipient-names'));
    document.getElementById('modal-facestack-sender').src = sender.get('ProfileImage').url();
    for (var i = 0; i < recipients.length; i++) {
      const rImg = document.createElement('img');
      rImg.src = recipients[i].get('ProfileImage').url();
      document.getElementById('modal-facestacksub').appendChild(rImg);
      const sp = document.createElement('span');
      sp.innerHTML = `${recipients[i].get('Name')}${(recipients.length == 1 ? '' : (i == 0 && recipients.length == 2 ? ' and ' : (i < recipients.length - 2 ? ', ' : (i < recipients.length - 1 ? ', and ' : ''))))}`;
      document.getElementById('modal-recipient-names').appendChild(sp);
    }
    document.getElementById('modal-sender-name').innerHTML = sender.get('Name');
    document.getElementById('modal-message').innerHTML = messageContent;
  }
}

const modalCloseButtonClicked = () => {
  modal.style.display = 'none';
}

async function getPeeps() {
  if (!shouldLoadPeepsFromAPI()) {
    peeps = localStorage.getObject(`${STORAGE_ROOT}peeps_data`);
  }
  const query = new Parse.Query('Player');
  query.equalTo('Active', true);
  query.notEqualTo('Name', 'Other');
  query.select('Name', 'Email', 'ProfileImage');
  query.ascending('Name');
  try {
    peeps = await query.find();
  } catch (error) {
    throw (error);
  }
};

const shouldLoadPeepsFromAPI = () => {
  const data = localStorage.getObject(`${STORAGE_ROOT}peeps_data`);
  const d = new Date();
  const day = d.getDay();
  const lastDay = localStorage.getObject(`${STORAGE_ROOT}peeps_load`);
  if (lastDay == null || data == null) {
    localStorage.setObject(`${STORAGE_ROOT}peeps_load`, day);
    return true;
  }
  return day != lastDay; // only refresh if a new day
}

const setUpInputField = () => {
  mentionablePeeps = peeps.filter(p => p.id != funsizerParseId).map(p => ({ id: p.id, value: p.get('Name') }));
  var options = {
    formats: ["mention"],
    placeholder: '@ mention one or more folks and tell them what their Funfive is for.',
    modules: {
      mention: {
        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
        mentionDenotationChars: ["@"],
        source: function (searchTerm, renderList) {
          if (searchTerm.length === 0) {
            renderList(currentlyMentionablePeeps, searchTerm);
          } else {
            const matches = [];
            for (let i = 0; i < currentlyMentionablePeeps.length; i++) {
              if (~currentlyMentionablePeeps[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) { matches.push(currentlyMentionablePeeps[i]); }
            }
            renderList(matches, searchTerm);
          }
        },
        onBeforeClose: function () {
          currentlyMentionedPeeps = [];
          quill.getContents().ops.forEach(op => {
            if (typeof op.insert !== 'string') {
              currentlyMentionedPeeps.push(op.insert.mention);
            }
          });
          currentlyMentionablePeeps = mentionablePeeps.filter(mp => !currentlyMentionedPeeps.find(cmp => cmp.id === mp.id));
        },
        mentionContainerClass: 'mention-container',
        listItemClass: 'mention-list-item',
      }
    }
  };
  quill = new Quill('#funfive-quill', options);
};

const itsASubmitButtonClicked = () => {
  if (currentlyMentionedPeeps.length < 1) {
    alert('Who are you trying to FunFive? 🤔');
    return;
  }
  ffMessage = getParsedMessage();
  if (ffMessage === '') {
    alert('Why are you giving a FunFive? 🤔');
    return;
  }
  createFunFive().then(() => {
    quill.setContents([{ insert: '\n' }]);
    currentlyMentionedPeeps = [];
    currentlyMentionablePeeps = [];
    ffMessage = '';
    getFunFives(true).then(() => {
      currentFives = funfives;
      updateGivenReceivedArrays();
      renderFivesCore();
      runConfirmationSequence();
    }).catch(function (e) {
      handleParseError('Error when gettin funfives', e);
      console.log(`Error when gettin funfives : ${e.code} - ${e.message}`);
    });
  }).catch(function (e) {
    handleParseError('Error when creating the FunFive', e);
    console.log(`Error when the FunFive : ${e.code} - ${e.message}`);
  });
}

const getParsedMessage = () => {
  // For improved funfive readability 
  // if the message begins with mentions - and potentially an "and" - then parse all that out
  // but keep any mentions within the message proper
  var nowInMessage = false;
  var msg = '';
  const contents = quill.getContents().ops;
  console.log(contents)
  for(var i = 0; i < contents.length; i++){
    if(typeof contents[i].insert === 'string') {
      console.log(contents[i])
      if(!nowInMessage && 
         (contents[i].insert.toLowerCase().replace(',', '').trim() === 'and' || contents[i].insert === ' ') && (i-1 >= 0) && 
         (typeof contents[i-1].insert !== 'string') && 
         (i+1 < contents.length) && 
         (typeof contents[i+1].insert !== 'string')) { 
        continue; 
      }
      nowInMessage = true;
      msg += contents[i].insert;
    }
    else {
      if(nowInMessage) { 
        msg += contents[i].insert.mention.value; 
      }
    }
  }
  return msg;
}

async function getFunFives(forceAPI = false) {
  if (!forceAPI && !shouldLoadFunFivesFromAPI()) {
    funfives = localStorage.getObject(`${STORAGE_ROOT}ff_data`);
  }
  const query = new Parse.Query('FunFive');
  query.descending('createdAt');
  try {
    funfives = await query.find();
  } catch (error) {
    throw (error);
  }
};

const ffTime = 5 * 60 * 1000;  //every 5 minutes
const shouldLoadFunFivesFromAPI = () => {
  const now = Date.now();
  const lastTime = localStorage.getObject(`${STORAGE_ROOT}ff_load`);
  const data = localStorage.getObject(`${STORAGE_ROOT}ff_data`);
  if (lastTime == null || data == null) {
    localStorage.setObject(`${STORAGE_ROOT}ff_load`, now);
    return true;
  }
  return (now - lastTime) > ffTime;
}

const renderFunFives = () => {
  noFives.style.display = 'none';
  removeAllChildNodes(funFiveFeed);
  for (var i = 0; i < currentFives.length; i++) {
    renderFunFive(currentFives[i], false);
  }
};

const renderFunFive = (data, isUpdate) => {
  var currentDate = '';
  const dateString = String(data.createdAt);
  const dateTrimmed = (dateString.substring(4, 15));

  const senderId = data.get('SenderId');
  const recipientIds = data.get('RecipientIds');
  const sender = peeps.filter(p => p.id == senderId)[0];
  const recipients = peeps.filter(p => recipientIds.includes(p.id));
  const messageContent = data.get('Message');
  var dateBlock;

  if(isUpdate){
    dateBlock = document.getElementById(`ff-feed-item-${data.id}`);
    removeAllChildNodes(dateBlock);
  }
  else {
    dateBlock = document.createElement('div');
    dateBlock.id = `ff-feed-item-${data.id}`;
  }

  const funfive = document.createElement('li');
  const faceStack = document.createElement('span');
  faceStack.addEventListener('mouseenter', runFunFiveHover);
  const senderFace = document.createElement('img');
  faceStack.append(senderFace);
  var img = document.createElement('img');
  const metadata = document.createElement('p');
  const senderName = document.createElement('span');
  const recipientNames = document.createElement('span');
  const message = document.createElement('p');

  const reactBlock = document.createElement('div');

  dateBlock.classList.add('date-block');
  faceStack.classList.add('facestack');
  metadata.classList.add('metadata');
  senderName.setAttribute('id', 'sender-name');
  recipientNames.setAttribute('id', 'reciever-name');
  message.setAttribute('id', 'message');
  reactBlock.classList.add('react-block');

  if (currentDate != dateTrimmed) {
    currentDate = dateTrimmed;
    if (funFiveFeed.lastChild) { funFiveFeed.lastChild.classList.add('last'); }
    const sendDate = document.createElement('span');
    sendDate.classList.add('send-date');
    sendDate.innerHTML = dateTrimmed;
    dateBlock.append(sendDate);
  }

  if(!isUpdate){ funFiveFeed.append(dateBlock); }
  dateBlock.append(funfive);
  funfive.append(faceStack, metadata, message, reactBlock);

  img.src = new URL('../images/funfive.gif', import.meta.url);
  img.classList.add('ff-image');
  faceStack.appendChild(img);
  const faceStackSub = document.createElement('span');
  faceStackSub.classList.add('facestacksub');
  faceStack.appendChild(faceStackSub);
  var recipientsString = '';
  for (var j = 0; j < recipients.length; j++) {
    const rImg = document.createElement('img');
    rImg.src = recipients[j].get('ProfileImage').url();
    rImg.style.zIndex = j;
    faceStackSub.appendChild(rImg);
    recipientsString += `${recipients[j].get('Name')}${(recipients.length == 1 ? '' : (j == 0 && recipients.length == 2 ? ' and ' : (j < recipients.length - 2 ? ', ' : (j < recipients.length - 1 ? ', and ' : ''))))}`;
  }

  metadata.innerHTML = " to ";
  metadata.prepend(senderName);
  metadata.append(recipientNames);

  senderFace.src = sender.get('ProfileImage').url();
  senderName.innerHTML = sender.get('Name');
  recipientNames.innerHTML = recipientsString;
  message.innerHTML = messageContent;

  const ffReactions = data.get('Reactions');
  if(ffReactions){ buildFFReactions(ffReactions, reactBlock, data.id); }
  const reactBtnNew = document.createElement('button');
  reactBtnNew.classList.add('react-new');
  reactBtnNew.id = data.id;
  reactBtnNew.addEventListener('mouseup', newReaction);
  reactBlock.appendChild(reactBtnNew);
  const reactBtnImg = document.createElement('img');
  reactBtnImg.src = new URL('../svgs/reaction.svg', import.meta.url);
  reactBtnNew.append(reactBtnImg);
}

const buildFFReactions = (ffReactions, container, ffId) => {
  ffReactions.forEach(ffR => {
    if(ffR.ids.length > 0){
      const reactPill = document.createElement('button');
      reactPill.id = `${ffR.name},${ffId}`;
      const reactPillCounter = document.createElement('p');
      const reactPillEmoji = document.createElement('span');
      reactPill.classList.add('react-pill');
      reactPillEmoji.classList.add('emoji');
      reactPill.addEventListener('click', (e)=>{
        const ids = e.target.id.split(',');
        var ff = funfives.filter(f => f.id == ids[1])[0];
        var ffReactions = ff.get('Reactions');
        //this is a removal if current user is one of the ids otherwise it is an add
        const ffReaction = ffReactions.filter(r => r.name == ids[0])[0];
        if(ffReaction.ids.includes(funsizerParseId)){
          ffReaction.ids = ffReaction.ids.filter(id => id != funsizerParseId);
        }
        else {
          ffReaction.ids.push(funsizerParseId);
        }
        ff.set('Reactions', ffReactions);
        ff.save().then((r) => {
          ff = r;
          renderFunFive(ff, true);
        }, (error) => {
          alert('Failed saving reaction: ' + error);
        });
      });
    
      reactPillEmoji.innerHTML = reactions.filter(r => r.name == ffR.name)[0].value;
      reactPillCounter.innerHTML = `${ffR.ids.length}`;
      if(ffR.ids.includes(funsizerParseId)){
        reactPill.classList.add('selected');
      }
    
      const reactList = document.createElement('div');
      reactList.classList.add('react-list');
      var peepNames = '';
      for(var i = 0; i < ffR.ids.length; i++){
        const p = peeps.filter(p => p.id == ffR.ids[i])[0];
        peepNames += `<span> ${p.get('Name')}</span>${i == ffR.ids.length - 2 ? ', and ' : (i == ffR.ids.length - 1 ? '' : ',')}`;
      }
      reactList.innerHTML = `${peepNames} reacted with ${ffR.name}`;

      reactPill.append(reactPillEmoji, reactPillCounter, reactList);
      container.append(reactPill);
    }
  });
}

document.addEventListener('mousedown', function (e) {
  if (!reactMenu.classList.contains('thanos') && !reactMenu.contains(e.target)) {
    reactMenu.classList.add('thanos');
  }
});

const newReaction = (e) => {
  ffReactId = e.target.id;
  const btn = e.target;
  const cRect = btn.getBoundingClientRect();
  reactMenu.style.left = `${cRect.left - 6}px`;
  reactMenu.style.top = `${cRect.top + cRect.height + document.documentElement.scrollTop}px`;
  reactMenu.classList.remove('thanos');
}

const updateGivenReceivedArrays = () => {
  givenFives = currentFives.filter(x => x.get('SenderId') == funsizerParseId);
  receivedFives = currentFives.filter(x => x.get('RecipientIds').includes(funsizerParseId));
}

const renderFivesCore = () => {
  if (currentFives.length == 0) {
    renderEmptyFives();
  }
  else {
    renderFunFives();
  }
  renderGivenReceivedButtons();
};

const renderGivenReceivedButtons = () => {
  document.getElementById('given').innerHTML = givenFives.length;
  document.getElementById('received').innerHTML = receivedFives.length;
};

const renderEmptyFives = () => {
  removeAllChildNodes(funFiveFeed);
  noFives.style.display = 'flex';
};

const WEEK_LENGTH = 604800000;
const dateSelectorChanged = () => {
  dateSelectorCore();
  resetFilters();
  updateGivenReceivedArrays();
  renderFivesCore();
}

const dateSelectorCore = () => {
  const today = new Date();
  switch (selector.value) {
    case 'all':
      currentFives = funfives;
      break;
    case 'today':
      currentFives = funfives.filter(ff => {
        return ff.createdAt.getDate() == today.getDate() &&
          ff.createdAt.getMonth() == today.getMonth() &&
          ff.createdAt.getFullYear() == today.getFullYear()
      });
      break;
    case 'lweek':
      today.setDate(today.getDate() - (today.getDay() - 1) - 7);
      today.setHours(0, 0, 0, 0);
      currentFives = funfives.filter(ff => { return ff.createdAt.getTime() >= today.getTime() && ff.createdAt.getTime() < (today.getTime() + WEEK_LENGTH); });
      break;
    case 'lmonth':
      const lastMonth = (today.getMonth() - 1 < 0 ? 11 : today.getMonth() - 1);
      currentFives = funfives.filter(ff => { return ff.createdAt.getMonth() == lastMonth; });
      break;
    case 'tweek':
      today.setDate(today.getDate() - (today.getDay() - 1));
      today.setHours(0, 0, 0, 0);
      currentFives = funfives.filter(ff => { return ff.createdAt.getTime() >= today.getTime() && ff.createdAt.getTime() < (today.getTime() + WEEK_LENGTH); });
      break;
    case 'tmonth':
      currentFives = funfives.filter(ff => { return ff.createdAt.getMonth() == today.getMonth(); });
      break;
  }
}

const runConfirmationSequence = () => {
  const copy = document.getElementById('copy');
  const copyH = parseInt(window.getComputedStyle(copy, null).height.replace('px', ''));
  const form = document.querySelector('.new-fives');
  const confirm = document.querySelector('.new-fives-confirm');
  const leftH = document.getElementById('hand-1');
  const leftW = parseInt(window.getComputedStyle(leftH, null).width.replace('px', ''));
  const rightH = document.getElementById('hand-2');
  const rightW = parseInt(window.getComputedStyle(rightH, null).width.replace('px', ''));
  const smack = document.getElementById('smack');
  const cloudTL = document.getElementById('topleft');
  const cloudTLW = parseInt(window.getComputedStyle(cloudTL, null).width.replace('px', ''));
  const cloudTR = document.getElementById('topright');
  const cloudTRW = parseInt(window.getComputedStyle(cloudTR, null).width.replace('px', ''));
  const cloudBL = document.getElementById('bottomleft');
  const cloudBLW = parseInt(window.getComputedStyle(cloudBL, null).width.replace('px', ''));
  const cloudBR = document.getElementById('bottomright');
  const cloudBRW = parseInt(window.getComputedStyle(cloudBR, null).width.replace('px', ''));
  form.style.pointerEvents = 'none';
  gsap.set(copy, { opacity: 0, y: copyH });
  gsap.set(leftH, { x: -leftW * 1.7 });
  gsap.set(rightH, { x: rightW * 1.7 });
  gsap.set(smack, { opacity: 0, scale: 0 });
  gsap.set(cloudTL, { opacity: 0, x: -cloudTLW });
  gsap.set(cloudTR, { opacity: 0, x: cloudTRW });
  gsap.set(cloudBL, { opacity: 0, x: -cloudBLW });
  gsap.set(cloudBR, { opacity: 0, x: cloudBRW });
  gsap.to(confirm, { opacity: 1, duration: 0.5 });
  gsap.to(leftH, { x: leftW * 0.2, duration: 0.9, delay: 0.6, ease: 'elastic.out(1,1)' });
  gsap.to(rightH, { x: -rightW * 0.2, duration: 0.9, delay: 0.6, ease: 'elastic.out(1,1)' });
  gsap.to(cloudTL, { opacity: 1, x: cloudTLW * .1, duration: .4, delay: .3 });
  gsap.to(cloudTR, { opacity: 1, x: cloudTRW * .2, duration: .6, delay: .2 });
  gsap.to(cloudBL, { opacity: 1, x: -cloudBLW * .01, duration: .6, delay: .2 });
  gsap.to(cloudBR, { opacity: 1, x: cloudBRW * .1, duration: .4, delay: .3 });
  gsap.to(copy, {
    opacity: 1, y: 10, duration: 1, delay: .2, ease: 'power2.out',
    onComplete: () => {
      gsap.to(confirm, { opacity: 0, duration: .6, delay: 1.1 });
      form.style.pointerEvents = 'all';
    }
  });
  gsap.to(smack, {
    scale: 1, opacity: 1, duration: 0.6, delay: 0.8, ease: 'power2.out',
    onComplete: () => {
      gsap.to(smack, { opacity: 0, duration: 0.5 });
    }
  });
}

const runFunFiveHover = (e) => {
  const kids = Array.from(e.target.children).slice(2, e.target.children.length);
  const stagDur = 0.1;
  const clapper = e.target.children[1];
  gsap.to(kids, {
    x: 34, duration: 1, ease: 'elastic.out(1,0.4)', onComplete: () => {
      gsap.to(kids, { x: 0, duration: 1, ease: 'elastic.out(1,0.4)' });
    }
  });
  gsap.delayedCall(stagDur, () => {
    clapper.style.display = 'inline';
    gsap.to(clapper, {
      opacity: 1, duration: 0.5, onComplete: () => {
        gsap.to(clapper, { opacity: 0, duration: 0.5, delay: stagDur * 4 });
        gsap.to(clapper, { scale: 0, duration: 0.5, delay: stagDur * 4 });
      }
    })
    gsap.fromTo(clapper, { scale: 0 }, { scale: 1, ease: 'elastic.out(1,0.2)', duration: 0.5 })
  });
}

function handleParseError(msg, err) {
  switch (err.code) {
    case Parse.Error.INVALID_SESSION_TOKEN:
      Parse.User.logOut();
      window.location = `${window.location.origin}/${(window.location.pathname.includes("staging") ? "staging/" : "")}login.html?redirect=${window.location.pathname}`;
      break;
    default:
      console.log(`${msg} : ${err.code} - ${err.message}`);
  }
};

Storage.prototype.setObject = function (key, value) {
  this.setItem(key, JSON.stringify(value));
}

Storage.prototype.getObject = function (key) {
  var value = this.getItem(key);
  return value && JSON.parse(value);
}

const removeAllChildNodes = (parent) => {
  while (parent.firstChild) {
    parent.removeChild(parent.firstChild);
  }
};